import { Badge, Button, CloseButton, Form, FormControl, InputGroup, Stack } from "react-bootstrap";
import { ArrowCounterclockwise, PlusLg } from "react-bootstrap-icons";

import { axiosInstance } from "../../auth/Auth";
import { useState } from "react";
import ConfirmPrompt from "../ConfirmPrompt";

export default function BreakKeywords({ item, onKeywordsUpdate }) {
    const [showKeywordsResetConfirmPrompt, setShowKeywordsResetConfirmPrompt] = useState(false);

    async function addKeywordToBreak(event) {
        event.preventDefault();
        const formData = new FormData(event.target);
        const keyword = formData.get("keyword");
        if (!keyword || item.keywords.includes(keyword)) return;
        try {
            const keywords = [...item.keywords, keyword];
            onKeywordsUpdate(keywords);
            await axiosInstance.post(`/content_testing/${item.break_id}/keywords/?keyword=${encodeURIComponent(keyword)}`);
            event.target.reset();
        } catch (error) {
            console.error(error);
        }
    }
    async function removeKeywordFromBreak(keyword) {
        try {
            const keywords = item.keywords.filter(k => k !== keyword);
            onKeywordsUpdate(keywords);
            await axiosInstance.delete(`/content_testing/${item.break_id}/keywords/?keyword=${encodeURIComponent(keyword)}`);
        } catch (error) {
            console.error(error);
        }
    }
    async function resetKeywords() {
        try {
            onKeywordsUpdate(item.keywords_original);
            setShowKeywordsResetConfirmPrompt(false);
            await axiosInstance.post(`/content_testing/${item.break_id}/reset/?content_group=${false}&keyword=${true}`);
        } catch (error) {
            console.error(error);
        }
    }
    return (
        <>
            <Stack direction="horizontal" gap={1} className="flex-wrap">
                {item.keywords.map((x, i) => (
                    <Badge key={`${item.break_id}-${i}`} className="bg-ra-light-yellow text-dark fw-normal">
                        {x}
                        <CloseButton className="py-0" onClick={async () => await removeKeywordFromBreak(x)} />
                    </Badge>
                ))}
                <Stack direction="horizontal" gap={1}>
                    <Form onSubmit={addKeywordToBreak}>
                        <InputGroup size="sm" className=" new-keyword">
                            <FormControl type="text" name="keyword" placeholder="New keyword" className="fs-8 py-0" />
                            <Button type="submit" className=" btn-ra-yellow py-1 px-1 d-flex align-items-center">
                                <PlusLg />
                            </Button>
                        </InputGroup>
                    </Form>
                    <Button
                        size="sm"
                        variant="danger"
                        className=" d-flex align-items-center py-0 px-0"
                        title="Reset keywords changes."
                        disabled={JSON.stringify(item.keywords) === JSON.stringify(item.keywords_original)}
                        onClick={() => setShowKeywordsResetConfirmPrompt(true)}>
                        <ArrowCounterclockwise height={22} width={22} />
                    </Button>
                </Stack>
            </Stack>
            <ConfirmPrompt
                show={showKeywordsResetConfirmPrompt}
                handleClose={() => setShowKeywordsResetConfirmPrompt(false)}
                handleConfirm={() => resetKeywords()}
                confirmText="Reset"
                cancelText="Keep current"
                bodyText="Are you sure you want to reset keywords to original values? Any modifications will be lost."
            />
        </>
    );
}
